// components/AuthGuard.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import VipTeaser from './VipTeaser';
import { useCompetitions } from './CompetitionContext';

const useLeagueData = (leagueId) => {
  const [leagueData, setLeagueData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { competitions, loading: competitionsLoading } = useCompetitions();

  useEffect(() => {
    if (!leagueId) {
      setLeagueData(null);
      setError(null);
      setLoading(false);
      return;
    }
    if (competitionsLoading) {
      setLoading(true);
      return;
    }

    const foundLeague = Object.values(competitions || {})
      .flat()
      .find(comp => comp.competition_id === parseInt(leagueId, 10));

    setLeagueData(foundLeague || null);
    setError(foundLeague ? null : 'Liga nie zostala znaleziona.');
    setLoading(false);
  }, [leagueId, competitions, competitionsLoading]);

  return { leagueData, loading, error };
};


const AuthGuard = ({ children, requiredRole = 'admin' }) => {
  const { user, loading, hasRole, vipModeEnabled } = useAuth();
  
  console.log('AuthGuard render → vipModeEnabled:', vipModeEnabled);

  // 1. Najpierw zawsze czekamy na zakończenie ładowania
  if (loading) {
    return <div>Sprawdzanie uprawnień...</div>;
  }

  // 2. Po zakończeniu ładowania – sprawdzamy, czy użytkownik istnieje
  if (!user) {
    // użytkownik nie jest zalogowany → zawsze redirect na login
    return <Navigate to="/login" replace />;
  }

// ───────────────────────────────────────────────
  // Logika VIP – włączamy blokadę tylko gdy vipModeEnabled = true
  // ───────────────────────────────────────────────
  const isVipRequired = requiredRole === 'vip';
  const isBlockedForNonVip = isVipRequired && vipModeEnabled && !hasRole('vip');

  if (isBlockedForNonVip) {
    return <VipTeaser />;
  }

  // admin zawsze przechodzi (nawet gdy vipModeEnabled = true)
  if (requiredRole === 'admin' && !hasRole('admin')) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export { AuthGuard, useLeagueData };
